import React, { useEffect, useState } from "react"
import {
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CModalFooter,
} from "@coreui/react"
import { Checkbox, Flex, Input, Typography } from "antd"
import { useDispatch } from "react-redux"
import { versionAction } from "../../../store/Slices/VersionsSlice"

const AddEditVersionModal = ({ visible, setVisible, versionInfo }) => {
  const dispatch = useDispatch()

  const [publicId, setPublicId] = useState()
  const [iosCode, setIosCode] = useState()
  const [androidCode, setAndroidCode] = useState()
  const [isRequired, setIsRequired] = useState(false)
  const [requieredPercent, setRequieredPercent] = useState(null)

  useEffect(() => {
    setPublicId("")
    setIosCode("")
    setAndroidCode("")
    setIsRequired()
    setRequieredPercent(null)
  }, [visible.flag])

  useEffect(() => {
    if (visible.flag === "edit") {
      setPublicId(versionInfo?.id)
      setIosCode(versionInfo?.iosCode)
      setRequieredPercent(versionInfo?.requieredPercent)
      setIsRequired(Boolean(versionInfo?.isRequired))
      setAndroidCode(versionInfo?.androidCode)
    }
  }, [visible, versionInfo])

  const onClickSubmit = () => {
    dispatch(
      visible.flag === "edit"
        ? versionAction({
            flag: "post",
            value: {
              id: publicId,
              iosCode: iosCode,
              androidCode: androidCode,
              isRequired: isRequired,
              requieredPercent: requieredPercent,
            },
          })
        : versionAction({
            flag: "put",
            value: {
              iosCode: Number(iosCode),
              androidCode: Number(androidCode),
              isRequired: isRequired,
              requieredPercent: Number(requieredPercent),
            },
          }),
    ).then(() => {
      dispatch(versionAction({ flag: "get" }))
      setVisible(false)
    })
  }

  const handleChangeRequieredPercent = (value) => {
    const cleanValue = value.replace(/[^0-9.]/g, "")

    const dotCount = (cleanValue.match(/\./g) || []).length
    if (dotCount > 1) return

    if (cleanValue === "" || cleanValue === ".") {
      setRequieredPercent(cleanValue)
      return
    }

    const numValue = Number(cleanValue)

    if (isNaN(numValue)) {
      setRequieredPercent(cleanValue)
      return
    }

    if (numValue >= 0 && numValue <= 100) {
      setRequieredPercent(cleanValue)
    } else {
      return
    }
  }

  return (
    <CModal
      alignment='center'
      visible={visible.open}
      aria-labelledby='VerticallyCenteredExample'
      onClose={() => {
        setVisible({ open: false, flag: "" })
      }}
      keyboard={true}
    >
      <CModalHeader>
        <CModalTitle id='VerticallyCenteredExample'>
          {visible.flag === "add" ? "Добавить версию" : "Редактировать версию"}
        </CModalTitle>
      </CModalHeader>
      <CModalBody
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Flex vertical gap={16} style={{ marginTop: "20px" }}>
          <>
            <div>
              <Typography.Title level={5}>Версия iOS</Typography.Title>
              <Input
                value={iosCode}
                onChange={(e) => setIosCode(e.currentTarget.value)}
              />
            </div>

            <div>
              <Typography.Title level={5}>Версия android</Typography.Title>
              <Input
                value={androidCode}
                onChange={(e) => setAndroidCode(e.currentTarget.value)}
              />
            </div>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              <div
                style={{ display: "flex", gap: "10px", alignItems: "center" }}
              >
                <Checkbox
                  onChange={() => setIsRequired(!isRequired)}
                  checked={isRequired}
                />
                <Typography.Title level={5} style={{ margin: 0 }}>
                  Необходимость скачивания
                </Typography.Title>
              </div>

              {isRequired ? (
                <div>
                  <Input
                    value={requieredPercent}
                    onChange={(e) =>
                      handleChangeRequieredPercent(e.target.value)
                    }
                    type='text'
                    placeholder='Введите процент (0-100)'
                  />
                </div>
              ) : null}
            </div>
          </>
        </Flex>
      </CModalBody>
      <CModalFooter>
        <CButton
          onClick={() => {
            setVisible({ open: false, flag: "" })
          }}
          className='text-light'
          color='secondary'
        >
          Закрыть
        </CButton>
        <CButton onClick={onClickSubmit} className='text-light'>
          {visible.flag === "add" ? "Добавить" : "Редактировать"}
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default AddEditVersionModal
